import {
  LabelFieldMapping,
  POCategoryFieldMapping,
  PORateKeyMapping,
} from 'constants/poRates.ts';
import _ from 'lodash';
import { SERVICE_TYPES } from 'enums/serviceTypes.ts';
import { isTemplateExpression } from 'typescript';
import { isEmptyVal } from 'utils/utils';
import { fetchFuelRates } from '../../store/slices/timesheet/timesheetDetailSlice';

export const serviceTypes = [
  { label: 'Labor', value: SERVICE_TYPES.LABOR },
  { label: 'Equipment', value: SERVICE_TYPES.EQUIPMENT },
  { label: 'Reimbursable Markup', value: SERVICE_TYPES.REIMBURSABLE_MARKUP },
  { label: 'Unit Price Task', value: SERVICE_TYPES.UNIT_PRICE_TASK },
  { label: 'Lumpsum', value: SERVICE_TYPES.LUMPSUM },
  { label: 'CU', value: SERVICE_TYPES.CU },
  { label: 'Production Hours', value: SERVICE_TYPES.PRODUCTION_HOURS },
];

export const serviceTypeObject = {
  [SERVICE_TYPES.LABOR]: 'Labor',
  [SERVICE_TYPES.EQUIPMENT]: 'Equipment',
  [SERVICE_TYPES.REIMBURSABLE_MARKUP]: 'Reimbursable Markup',
  [SERVICE_TYPES.UNIT_PRICE_TASK]: 'Unit Price Task',
  [SERVICE_TYPES.LUMPSUM]: 'Lumpsum',
  [SERVICE_TYPES.CU]: 'CU',
  [SERVICE_TYPES.PRODUCTION_HOURS]: 'Production Hours',
};

export const serviceTypeList = [
  SERVICE_TYPES.LABOR,
  SERVICE_TYPES.EQUIPMENT,
  SERVICE_TYPES.REIMBURSABLE_MARKUP,
  SERVICE_TYPES.UNIT_PRICE_TASK,
  SERVICE_TYPES.LUMPSUM,
  SERVICE_TYPES.CU,
  SERVICE_TYPES.PRODUCTION_HOURS,
];

// IMPORTANT NOTE: Do not change order of the objects in the lists below.
export const classificationList = {
  [SERVICE_TYPES.LABOR]: [
    {
      label: 'Rate Schedule',
      values: [''],
      value: '',
      name: 'rateschecode',
      required: true,
    },

    {
      label: 'Labor Code',
      values: [''],
      value: '',
      name: 'laborCode',
      required: true,
    },

    {
      label: 'Labor Category',
      values: [''],
      value: '',
      name: 'laborCategory',
      required: false,
    },

    {
      label: 'Activity',
      values: [''],
      value: '',
      name: 'activitynum',
      required: true,
    },

    {
      label: 'Work Description',
      values: [],
      value: '',
      name: 'workDesc',
      required: false,
    },

    {
      label: 'Employee Id',
      values: [],
      value: '',
      name: 'employeeId',
      required: false,
    },

    {
      label: 'Employee Name',
      values: [],
      value: '',
      name: 'employeeName',
      required: false,
    },
    {
      label: 'Shift',
      values: [''],
      value: '',
      name: 'shift',
      required: false,
    },
    {
      label: 'Straight Time (hrs)',
      values: [],
      value: '',
      name: 'regLaborHours',
      required: false,
    },
    {
      label: 'Over Time (hrs)',
      values: [],
      value: '',
      name: 'otLaborHours',
      required: false,
    },
    {
      label: 'Double Time (hrs)',
      values: [],
      value: '',
      name: 'dtLaborHours',
      required: false,
    },
    {
      label: 'Holiday Pay (hrs)',
      values: [],
      value: '',
      name: 'holidayPayHours',
      required: false,
    },
    {
      label: 'Travel (hrs)',
      values: [],
      value: '',
      name: 'travelHours',
      required: false,
    },
    {
      label: 'Peak Season (hrs)',
      values: [],
      value: '',
      name: 'peakSeasonHours',
      required: false,
    },
    {
      label: 'Emergency Call-out (hrs)',
      values: [],
      value: '',
      name: 'emerHours',
      required: false,
    },
    {
      label: 'Standby (hrs)',
      values: [],
      value: '',
      name: 'standbyHours',
      required: false,
    },
    {
      label: 'Mobilization (units)',
      values: [],
      value: '',
      name: 'mobUnits',
      required: false,
    },
    {
      label: 'Demobilization (units)',
      values: [],
      value: '',
      name: 'demobUnits',
      required: false,
    },
    {
      label: 'Per diem (units)',
      values: [],
      value: '',
      name: 'perDiemUnits',
      required: false,
    },
    {
      label: 'Daily (hrs)',
      values: [],
      value: '',
      name: 'dailyHours',
      required: false,
    },
    {
      label: 'Weekly (hrs)',
      values: [],
      value: '',
      name: 'weeklyHours',
      required: false,
    },
    {
      label: 'Monthly (hrs)',
      values: [],
      value: '',
      name: 'monthlyHours',
      required: false,
    },
    {
      label: 'RHX (hrs)',
      values: [],
      value: '',
      name: 'rhxHours',
      required: false,
    },
    {
      label: 'DTX (hrs)',
      values: [],
      value: '',
      name: 'dtxHours',
      required: false,
    },
    {
      label: 'Amount',
      values: [],
      value: '',
      name: 'lineAmount',
      required: false,
    },
  ],

  [SERVICE_TYPES.EQUIPMENT]: [
    {
      label: 'Rate Schedule',
      values: [''],
      value: '',
      name: 'rateschecode',
      required: true,
    },
    {
      label: 'Equipment Code',
      values: [''],
      value: '',
      name: 'equipCode',
      required: true,
    },

    {
      label: 'Equipment Category',
      values: [''],
      value: '',
      name: 'equipCategory',
      required: false,
    },

    {
      label: 'Activity',
      values: [''],
      value: '',
      name: 'activitynum',
      required: true,
    },

    {
      label: 'Work Description',
      values: [],
      value: '',
      name: 'workDesc',
      required: false,
    },
    {
      label: 'Unit of Measure',
      values: [],
      value: '',
      name: 'equipUnitmeasure',
      required: false,
    },
    {
      label: 'Owned or Leased',
      values: [],
      value: '',
      name: 'owned',
      required: false,
    },
    {
      label: 'Equipment Type',
      values: [],
      value: '',
      name: 'eqptype',
      required: false,
    },
    {
      label: 'Equipment Id',
      values: [{ value: '', label: 'Select' }],
      value: '',
      name: 'equipId',
      required: false,
    },
    {
      label: 'Equipment Rental Units',
      values: [],
      value: '',
      name: 'equipmentRentalUnits',
      required: false,
    },
    {
      label: 'Operating Time (hrs)',
      values: [],
      value: '',
      name: 'opHours',
      required: false,
    },
    {
      label: 'Standby Time (hrs)',
      values: [],
      value: '',
      name: 'stHours',
      required: false,
    },
    {
      label: 'Over Time (hrs)',
      values: [],
      value: '',
      name: 'otHours',
      required: false,
    },
    {
      label: 'Cost Per Mile',
      values: [],
      value: '',
      name: 'miles',
      required: false,
    },
    {
      label: 'Mobilization (units)',
      values: [],
      value: '',
      name: 'mobUnits',
      required: false,
    },
    {
      label: 'Demobilization (units)',
      values: [],
      value: '',
      name: 'demobUnits',
      required: false,
    },
    {
      label: 'Amount',
      values: [],
      value: '',
      name: 'lineAmount',
      required: false,
    },
  ],

  [SERVICE_TYPES.REIMBURSABLE_MARKUP]: [
    {
      label: 'Rate Schedule',
      values: [''],
      value: '',
      name: 'rateschecode',
      required: true,
    },

    {
      label: 'Reimbursable Code',
      values: [''],
      value: '',
      name: 'reimbCode',
      required: true,
    },

    {
      label: 'Activity',
      values: [''],
      value: '',
      name: 'activitynum',
      required: true,
    },
    {
      label: 'Work Description',
      values: [],
      value: '',
      name: 'workDesc',
      required: false,
    },
    {
      label: 'Unit of Measure',
      values: [],
      value: '',
      name: 'reimbUnitmeasure',
      required: false,
    },
    {
      label: 'Quantity',
      values: [],
      value: '',
      name: 'reimbQuantity',
      required: false,
    },
    {
      label: 'Price',
      values: [],
      value: '',
      name: 'reimbPrice',
      required: false,
    },
    {
      label: 'Amount',
      values: [],
      value: '',
      name: 'lineAmount',
      required: false,
    },
  ],

  [SERVICE_TYPES.UNIT_PRICE_TASK]: [
    {
      label: 'Rate Schedule',
      values: [''],
      value: '',
      name: 'rateschecode',
      required: true,
    },

    {
      label: 'Unit Price Code',
      values: [''],
      value: '',
      name: 'code',
      required: true,
    },

    {
      label: 'Activity',
      values: [''],
      value: '',
      name: 'activitynum',
      required: true,
    },
    {
      label: 'Work Description',
      values: [],
      value: '',
      name: 'workDesc',
      required: false,
    },
    {
      label: 'Unit of Measure',
      values: [],
      value: '',
      name: 'unitmeasure',
      required: false,
    },
    {
      label: 'Quantity',
      values: [],
      value: '',
      name: 'quantity',
      required: false,
    },
    {
      label: 'Equipment & Labor Unit Price',
      values: [],
      value: '',
      name: 'unitPriceEqptLabor',
      required: false,
    },
    {
      label: 'Labor Unit Price',
      values: [],
      value: '',
      name: 'unitPriceLabor',
      required: false,
    },
    {
      label: 'Equipment Unit Price',
      values: [],
      value: '',
      name: 'unitPriceEqpt',
      required: false,
    },
    {
      label: 'Material Unit Price',
      values: [],
      value: '',
      name: 'unitPriceMatl',
      required: false,
    },
    {
      label: 'Total Unit Price',
      values: [],
      value: '',
      name: 'totalPrice',
      required: false,
    },
    {
      label: 'Total Line Price',
      values: [],
      value: '',
      name: 'lineAmount',
      required: false,
    },
    {
      label: 'Hours',
      values: [],
      value: '',
      name: 'hours',
    },
    // {
    //   label: 'Amount',
    //   values: [],
    //   value: '',
    //   name: 'lineAmount',
    //   required: false,
    // },
  ],

  [SERVICE_TYPES.CU]: [
    {
      label: 'Rate Schedule',
      values: [''],
      value: '',
      name: 'rateschecode',
      required: true,
    },
    {
      label: 'CU Code',
      values: [''],
      value: '',
      name: 'cuGroupCode',
      required: true,
    },
    {
      label: 'Unit of Measure',
      values: [],
      value: '',
      name: 'cuUnitmeasure',
      required: false,
    },
    {
      label: 'Activity',
      values: [''],
      value: '',
      name: 'activitynum',
      required: true,
    },
    {
      label: 'Work Description',
      values: [],
      value: '',
      name: 'workDesc',
      required: false,
    },
    {
      label: 'Quantity',
      values: [],
      value: '',
      name: 'quantity',
      required: false,
    },
    {
      label: 'Install Price',
      values: [],
      value: '',
      name: 'installPrice',
      required: false,
    },
    {
      label: 'Remove Price',
      values: [],
      value: '',
      name: 'removePrice',
      required: false,
    },
    {
      label: 'Transfer Price',
      values: [],
      value: '',
      name: 'transferPrice',
      required: false,
    },
    {
      label: 'Small Job Markup',
      values: [],
      value: '',
      name: 'smallJobAmount',
      required: false,
    },
    {
      label: 'Travel Amount',
      values: [],
      value: '',
      name: 'travelAmount',
      required: false,
    },
    {
      label: 'De-Energized Amount',
      values: [],
      value: '',
      name: 'deEnergizedAmount',
      required: false,
    },
    {
      label: 'Amount',
      values: [],
      value: '',
      name: 'lineAmount',
      required: false,
    },
  ],

  [SERVICE_TYPES.LUMPSUM]: [
    {
      label: 'Activity',
      values: [''],
      value: '',
      name: 'activitynum',
      required: true,
    },
    {
      label: 'Amount',
      values: [],
      value: '',
      name: 'amount',
      required: false,
    },
    {
      label: 'Work Description',
      values: [],
      value: '',
      name: 'workDesc',
      required: false,
    },
    {
      label: 'Amount',
      values: [],
      value: '',
      name: 'lineAmount',
      required: false,
    },
  ],

  [SERVICE_TYPES.PRODUCTION_HOURS]: [
    {
      label: 'Unit Price Code',
      values: [''],
      value: '',
      name: 'code',
      required: true,
    },
    {
      label: 'Unit of Measure',
      values: [],
      value: '',
      name: 'unitmeasure',
      required: false,
    },
    {
      label: 'Quantity/Unit',
      values: [],
      value: '',
      name: 'quantity',
      required: false,
    },
    {
      label: 'Hours',
      values: [],
      value: '',
      name: 'hours',
      required: false,
    },
  ],
};

export const classificationInvoice = {};
for (const itm in classificationList) {
  for (const item of classificationList[itm]) {
    classificationInvoice[item.name] = item.label;
  }
}
export function getClassificationLabel(name) {
  return classificationInvoice[name] || name;
}

export const getPORateObject = (
  purchaseOrderObject,
  classificationName,
  rateschValue,
  codeValue,
  categoryValue,
) => {
  let rateObject = null;

  if (
    !isEmptyVal(rateschValue) &&
    !isEmptyVal(codeValue) &&
    !isEmptyVal(categoryValue)
  ) {
    const rateSchField = LabelFieldMapping['rateSchLabel'];
    const codeField = LabelFieldMapping['codeLabel'];
    const categoryField = POCategoryFieldMapping[classificationName];

    rateObject = purchaseOrderObject[PORateKeyMapping[classificationName]].find(
      fObj =>
        fObj[rateSchField] === rateschValue &&
        fObj[codeField] === codeValue &&
        fObj[categoryField] === categoryValue,
    );
  } else if (!isEmptyVal(rateschValue) && !isEmptyVal(codeValue)) {
    const rateSchField = LabelFieldMapping['rateSchLabel'];
    const codeField = LabelFieldMapping['codeLabel'];

    rateObject = purchaseOrderObject[PORateKeyMapping[classificationName]].find(
      fObj =>
        fObj[rateSchField] === rateschValue && fObj[codeField] === codeValue,
    );
  }

  return rateObject;
};

export const setFilteredDropdownOptions = (
  tempClassifications,
  classificationName,
  classificationIndex,
  rowIndex,
  rateObj,
) => {
  // Rate Schedule
  tempClassifications[classificationIndex].values[rowIndex][0]['values'] = [
    { value: '', label: 'Select' },
    {
      value: rateObj[LabelFieldMapping['rateSchLabel']],
      label: rateObj[LabelFieldMapping['rateSchLabel']],
    },
  ];

  // Code
  tempClassifications[classificationIndex].values[rowIndex][1]['values'] = [
    { value: '', label: 'Select' },
    {
      value: rateObj[LabelFieldMapping['codeLabel']],
      label: rateObj[LabelFieldMapping['codeLabel']],
    },
  ];

  // Category
  if (
    [SERVICE_TYPES.LABOR, SERVICE_TYPES.EQUIPMENT].includes(classificationName)
  ) {
    tempClassifications[classificationIndex].values[rowIndex][2]['values'] = [
      { value: '', label: 'Select' },
      {
        value: rateObj[POCategoryFieldMapping[classificationName]],
        label: rateObj[POCategoryFieldMapping[classificationName]],
      },
    ];
  }
};

export const resetDropdownOptions = (
  lookup,
  tempClassifications,
  classificationName,
  classificationIndex,
  rowIndex,
  setValue,
) => {
  const fieldValue = '';
  const rateschFieldName =
    tempClassifications[classificationIndex].values[rowIndex][0]['name'];

  const codeFieldName =
    tempClassifications[classificationIndex].values[rowIndex][1]['name'];

  const categoryFieldName =
    tempClassifications[classificationIndex].values[rowIndex][2]['name'];

  // Rate schedule
  tempClassifications[classificationIndex].values[rowIndex][0]['value'] =
    fieldValue;
  tempClassifications[classificationIndex].values[rowIndex][0]['values'] =
    lookup?.rateScheduleOptions[classificationName];
  setValue(
    // @ts-ignore
    `${classificationName}.${rowIndex}.${rateschFieldName}`,
    fieldValue,
  );

  // Code
  tempClassifications[classificationIndex].values[rowIndex][1]['value'] =
    fieldValue;
  tempClassifications[classificationIndex].values[rowIndex][1]['values'] =
    lookup?.codeOptions[classificationName];
  setValue(
    // @ts-ignore
    `${classificationName}.${rowIndex}.${codeFieldName}`,
    fieldValue,
  );

  // Category
  if (
    [SERVICE_TYPES.LABOR, SERVICE_TYPES.EQUIPMENT].includes(classificationName)
  ) {
    tempClassifications[classificationIndex].values[rowIndex][2]['value'] =
      fieldValue;
    tempClassifications[classificationIndex].values[rowIndex][2]['values'] =
      lookup?.categoryOptions[classificationName];
    setValue(
      // @ts-ignore
      `${classificationName}.${rowIndex}.${categoryFieldName}`,
      fieldValue,
    );
  } else if (classificationName === SERVICE_TYPES.PRODUCTION_HOURS) {
    // Unit Price Code
    tempClassifications[classificationIndex].values[rowIndex][0]['value'] =
      fieldValue;
    tempClassifications[classificationIndex].values[rowIndex][0]['values'] =
      lookup?.serviceItemsOptions[classificationName];
    setValue(
      // @ts-ignore
      `${classificationName}.${rowIndex}.${rateschFieldName}`,
      fieldValue,
    );

    // UOM
    tempClassifications[classificationIndex].values[rowIndex][1]['value'] =
      fieldValue;
    tempClassifications[classificationIndex].values[rowIndex][1]['values'] =
      lookup?.unitOfMeasureOptions[classificationName];
    setValue(
      // @ts-ignore
      `${classificationName}.${rowIndex}.${codeFieldName}`,
      fieldValue,
    );
  }
};

export const setAutoPopulatedFields = (
  purchaseOrderObject,
  tempClassifications,
  classificationName,
  classificationIndex,
  rowIndex,
  rateschValue,
  codeValue,
  categoryValue,
  setValue,
  getValues,
) => {
  const rateObject = getPORateObject(
    purchaseOrderObject,
    classificationName,
    rateschValue,
    codeValue,
    categoryValue,
  );

  if (!isEmptyVal(rateObject)) {
    if (classificationName === SERVICE_TYPES.EQUIPMENT) {
      // Auto populate `unit of measure` field
      tempClassifications[classificationIndex].values[rowIndex][5]['value'] =
        rateObject.unitmeasure;
      setValue(
        // @ts-ignore
        `${classificationName}.${rowIndex}.equipUnitmeasure`,
        rateObject.unitmeasure,
      );

      // Auto populate `owned or leased` field
      tempClassifications[classificationIndex].values[rowIndex][6]['value'] =
        rateObject.owned;
      setValue(
        // @ts-ignore
        `${classificationName}.${rowIndex}.owned`,
        rateObject.owned,
      );

      // Auto populate `equipment type` field
      tempClassifications[classificationIndex].values[rowIndex][7]['value'] =
        rateObject.eqpttype;
      setValue(
        // @ts-ignore
        `${classificationName}.${rowIndex}.eqptype`,
        rateObject.eqpttype,
      );
    } else if (classificationName === SERVICE_TYPES.REIMBURSABLE_MARKUP) {
      // Auto populate `unit of measure` field
      tempClassifications[classificationIndex].values[rowIndex][4]['value'] =
        rateObject.unitmeasure;
      setValue(
        // @ts-ignore
        `${classificationName}.${rowIndex}.reimbUnitmeasure`,
        rateObject.unitmeasure,
      );

      // Auto populate `price` field
      tempClassifications[classificationIndex].values[rowIndex][6]['value'] =
        rateObject.price;
      setValue(
        // @ts-ignore
        `${classificationName}.${rowIndex}.reimbPrice`,
        rateObject.price,
      );
    } else if (classificationName === SERVICE_TYPES.UNIT_PRICE_TASK) {
      // Autopopulate unit of measure field
      const unitMeasureList = tempClassifications[classificationIndex].values[
        rowIndex
      ].filter(obj => obj.name === 'unitmeasure');
      if (unitMeasureList.length) {
        unitMeasureList[0].value = rateObject.unitmeasure;
        setValue(
          // @ts-ignore
          `${classificationName}.${rowIndex}.unitmeasure`,
          rateObject.unitmeasure,
        );
      }

      // Autopopulate Equipment and Labor unit price field
      const upEqpLaborList = tempClassifications[classificationIndex].values[
        rowIndex
      ].filter(obj => obj.name === 'unitPriceEqptLabor');
      if (upEqpLaborList.length) {
        let parsedValue = null;
        try {
          parsedValue = parseFloat(rateObject.eqptlabunitprice);
        } catch (e) {}
        parsedValue = isNaN(parsedValue) ? null : parsedValue;

        upEqpLaborList[0].value = parsedValue;
        setValue(
          // @ts-ignore
          `${classificationName}.${rowIndex}.unitPriceEqptLabor`,
          parsedValue,
        );
      }

      // Autopopulate Labor unit price field
      const laborList = tempClassifications[classificationIndex].values[
        rowIndex
      ].filter(obj => obj.name === 'unitPriceLabor');
      if (laborList.length) {
        let parsedValue = null;
        try {
          parsedValue = parseFloat(rateObject.unplabor);
        } catch (e) {}
        parsedValue = isNaN(parsedValue) ? null : parsedValue;

        laborList[0].value = parsedValue;
        setValue(
          // @ts-ignore
          `${classificationName}.${rowIndex}.unitPriceLabor`,
          parsedValue,
        );
      }

      // Autopopulate Equipment unit price field
      const eqptList = tempClassifications[classificationIndex].values[
        rowIndex
      ].filter(obj => obj.name === 'unitPriceEqpt');
      if (eqptList.length) {
        let parsedValue = null;
        try {
          parsedValue = parseFloat(rateObject.eqpuntprice);
        } catch (e) {}
        parsedValue = isNaN(parsedValue) ? null : parsedValue;

        eqptList[0].value = parsedValue;
        setValue(
          // @ts-ignore
          `${classificationName}.${rowIndex}.unitPriceEqpt`,
          parsedValue,
        );
      }

      // Autopopulate Material unit price field
      const materialList = tempClassifications[classificationIndex].values[
        rowIndex
      ].filter(obj => obj.name === 'unitPriceMatl');
      if (materialList.length) {
        let parsedValue = null;
        try {
          parsedValue = parseFloat(rateObject.upmatl);
        } catch (e) {}
        parsedValue = isNaN(parsedValue) ? null : parsedValue;

        materialList[0].value = parsedValue;
        setValue(
          // @ts-ignore
          `${classificationName}.${rowIndex}.unitPriceMatl`,
          parsedValue,
        );
      }

      // Autopopulate Total unit price field
      const totalPriceList = tempClassifications[classificationIndex].values[
        rowIndex
      ].filter(obj => obj.name === 'totalPrice');
      if (totalPriceList.length) {
        let parsedValue = null;
        try {
          parsedValue = parseFloat(rateObject.totalunitprice);
        } catch (e) {}
        parsedValue = isNaN(parsedValue) ? null : parsedValue;

        totalPriceList[0].value = parsedValue;
        setValue(
          // @ts-ignore
          `${classificationName}.${rowIndex}.totalPrice`,
          parsedValue,
        );
      }

      // Autopopulate Total line price field
      const qty = getValues(
        // @ts-ignore
        `${classificationName}.${rowIndex}.quantity`,
      );
      const totlPrice = getValues(
        // @ts-ignore
        `${classificationName}.${rowIndex}.totalPrice`,
      );
      let linePrice = null;
      try {
        linePrice = (qty * totlPrice).toFixed(2);
      } catch (e) {}
      linePrice = isNaN(linePrice) ? null : linePrice;

      const linePriceList = tempClassifications[classificationIndex].values[
        rowIndex
      ].filter(obj => obj.name === 'lineAmount');
      if (linePriceList.length) {
        linePriceList[0].value = linePrice;
        setValue(
          // @ts-ignore
          `${classificationName}.${rowIndex}.lineAmount`,
          linePrice,
        );
      }
    } else if (classificationName === SERVICE_TYPES.CU) {
      // Autopopulate unit of measure field
      tempClassifications[classificationIndex].values[rowIndex][2]['value'] =
        rateObject.unitmeasure;
      setValue(
        // @ts-ignore
        `${classificationName}.${rowIndex}.cuUnitmeasure`,
        rateObject.unitmeasure,
      );

      // Autopopulate Install price field
      tempClassifications[classificationIndex].values[rowIndex][6]['value'] =
        rateObject.installrate;
      setValue(
        // @ts-ignore
        `${classificationName}.${rowIndex}.installPrice`,
        rateObject.installrate,
      );

      // Autopopulate Remove price field
      tempClassifications[classificationIndex].values[rowIndex][7]['value'] =
        rateObject.removerate;
      setValue(
        // @ts-ignore
        `${classificationName}.${rowIndex}.removePrice`,
        rateObject.removerate,
      );

      // Autopopulate Transfer price field
      tempClassifications[classificationIndex].values[rowIndex][8]['value'] =
        rateObject.transferrate;
      setValue(
        // @ts-ignore
        `${classificationName}.${rowIndex}.transferPrice`,
        rateObject.transferrate,
      );

      // Autopopulate Small Job Markup field
      tempClassifications[classificationIndex].values[rowIndex][9]['value'] =
        rateObject.smalljobmarkup;
      setValue(
        // @ts-ignore
        `${classificationName}.${rowIndex}.smallJobAmount`,
        rateObject.smalljobmarkup,
      );
    }
  }
};

export const resetAutoPopulatedFields = (
  tempClassifications,
  classificationName,
  classificationIndex,
  rowIndex,
  setValue,
) => {
  if (classificationName === SERVICE_TYPES.EQUIPMENT) {
    // Auto populate `unit of measure` on selection of code
    tempClassifications[classificationIndex].values[rowIndex][5]['value'] = '';
    setValue(
      // @ts-ignore
      `${classificationName}.${rowIndex}.equipUnitmeasure`,
      '',
    );

    // Auto populate `owned or leased` field on selection of code
    tempClassifications[classificationIndex].values[rowIndex][6]['value'] = '';
    setValue(
      // @ts-ignore
      `${classificationName}.${rowIndex}.owned`,
      '',
    );

    // Auto populate `equipment type` field on selection of code
    tempClassifications[classificationIndex].values[rowIndex][7]['value'] = '';
    setValue(
      // @ts-ignore
      `${classificationName}.${rowIndex}.eqptype`,
      '',
    );
  } else if (classificationName === SERVICE_TYPES.REIMBURSABLE_MARKUP) {
    // Auto populate unit of measure on selection of code
    tempClassifications[classificationIndex].values[rowIndex][4]['value'] = '';
    setValue(
      // @ts-ignore
      `${classificationName}.${rowIndex}.reimbUnitmeasure`,
      '',
    );

    // Auto populate `price` field on selection of code
    tempClassifications[classificationIndex].values[rowIndex][6]['value'] = '';
    setValue(
      // @ts-ignore
      `${classificationName}.${rowIndex}.reimbPrice`,
      '',
    );
  } else if (classificationName === SERVICE_TYPES.UNIT_PRICE_TASK) {
    // Autopopulate unit of measure field
    const unitMeasureList = tempClassifications[classificationIndex].values[
      rowIndex
    ].filter(obj => obj.name === 'unitmeasure');
    if (unitMeasureList.length) {
      unitMeasureList[0].value = '';
      setValue(
        // @ts-ignore
        `${classificationName}.${rowIndex}.unitmeasure`,
        '',
      );
    }

    // Autopopulate Equipment and Labor unit price field
    const upEqpLaborList = tempClassifications[classificationIndex].values[
      rowIndex
    ].filter(obj => obj.name === 'unitPriceEqptLabor');
    if (upEqpLaborList.length) {
      upEqpLaborList[0].value = null;
      setValue(
        // @ts-ignore
        `${classificationName}.${rowIndex}.unitPriceEqptLabor`,
        null,
      );
    }

    // Autopopulate Labor unit price field
    const laborList = tempClassifications[classificationIndex].values[
      rowIndex
    ].filter(obj => obj.name === 'unitPriceLabor');
    if (laborList.length) {
      let parsedValue = null;
      laborList[0].value = parsedValue;
      setValue(
        // @ts-ignore
        `${classificationName}.${rowIndex}.unitPriceLabor`,
        parsedValue,
      );
    }

    // Autopopulate Equipment unit price field
    const eqptList = tempClassifications[classificationIndex].values[
      rowIndex
    ].filter(obj => obj.name === 'unitPriceEqpt');
    if (eqptList.length) {
      let parsedValue = null;
      eqptList[0].value = parsedValue;
      setValue(
        // @ts-ignore
        `${classificationName}.${rowIndex}.unitPriceEqpt`,
        parsedValue,
      );
    }

    // Autopopulate Material unit price field
    const materialList = tempClassifications[classificationIndex].values[
      rowIndex
    ].filter(obj => obj.name === 'unitPriceMatl');
    if (materialList.length) {
      let parsedValue = null;
      materialList[0].value = parsedValue;
      setValue(
        // @ts-ignore
        `${classificationName}.${rowIndex}.unitPriceMatl`,
        parsedValue,
      );
    }

    // Autopopulate Total unit price field
    const totalPriceList = tempClassifications[classificationIndex].values[
      rowIndex
    ].filter(obj => obj.name === 'totalPrice');
    if (totalPriceList.length) {
      let parsedValue = null;
      totalPriceList[0].value = parsedValue;
      setValue(
        // @ts-ignore
        `${classificationName}.${rowIndex}.totalPrice`,
        parsedValue,
      );
    }

    // Autopopulate Total line price field
    const linePriceList = tempClassifications[classificationIndex].values[
      rowIndex
    ].filter(obj => obj.name === 'lineAmount');
    if (linePriceList.length) {
      linePriceList[0].value = null;
      setValue(
        // @ts-ignore
        `${classificationName}.${rowIndex}.lineAmount`,
        null,
      );
    }
  } else if (classificationName === SERVICE_TYPES.CU) {
    // Autopopulate unit of measure field
    tempClassifications[classificationIndex].values[rowIndex][2]['value'] = '';
    setValue(
      // @ts-ignore
      `${classificationName}.${rowIndex}.cuUnitmeasure`,
      '',
    );

    // Autopopulate Install price field
    tempClassifications[classificationIndex].values[rowIndex][6]['value'] = '';
    setValue(
      // @ts-ignore
      `${classificationName}.${rowIndex}.cuUnitmeasure`,
      '',
    );

    // Autopopulate Remove price field
    tempClassifications[classificationIndex].values[rowIndex][7]['value'] = '';
    setValue(
      // @ts-ignore
      `${classificationName}.${rowIndex}.cuUnitmeasure`,
      '',
    );

    // Autopopulate Transfer price field
    tempClassifications[classificationIndex].values[rowIndex][8]['value'] = '';
    setValue(
      // @ts-ignore
      `${classificationName}.${rowIndex}.cuUnitmeasure`,
      '',
    );

    // Autopopulate Small Job Markup field
    tempClassifications[classificationIndex].values[rowIndex][9]['value'] = '';
    setValue(
      // @ts-ignore
      `${classificationName}.${rowIndex}.cuUnitmeasure`,
      '',
    );
  }
};

export const calculateLumpsum = (po, timesheet) => {
  const timesheetLumpsumData = timesheet?.timesheetLumpsums;
  const type = 'lumpsum';
  const lineData = [];
  for (let i = 0; i < timesheetLumpsumData.length; i++) {
    const costActivityData = po?.costActivities.find(
      obj =>
        obj.costactivityid == timesheetLumpsumData[i].activitynum &&
        obj.poid === po?.poid,
    );
    const polinenum = costActivityData ? costActivityData.polinenum : null;
    const lineItem = {
      [`${type}Rate`]: 1,
      [`${type}Units`]: timesheetLumpsumData[i].amount,
      activitynum: timesheetLumpsumData[i].activitynum,
      activityDescription: timesheetLumpsumData[i].workDesc,
      lineTotal: timesheetLumpsumData[i].lineAmount,
      polinenum: polinenum ? polinenum.toString() : '',
      timesheetId: timesheetLumpsumData[i]?.recordNmbr,
    };
    lineData.push(lineItem);
  }
  let total = 0;
  lineData.forEach(itm => {
    itm.lineTotal = itm.lumpsumUnits * itm.lumpsumRate;
    itm.lineTotal = Math.round(itm.lineTotal * 100) / 100;
    total += itm.lineTotal;
    total = Math.round(total * 100) / 100;
  });

  return { lineData, total };
};

export const calculateLabor = async (po, timesheet) => {
  const polaborratesData = po?.originalData?.polaborrates;
  const timesheetLaborData = timesheet?.timesheetLabors;
  for (let i = 0; i < timesheetLaborData.length; i++) {
    const resData = polaborratesData.find(porim => {
      const laborMatch = porim.restype1 === timesheetLaborData[i]?.laborCode;
      let dateRangeMatch = '';
      if (['DISTRIBUTION', 'FORESTRY'].includes(po?.buPath)) {
        const d =
          new Date(timesheet.weekEndDate).getTime() - 6 * 24 * 60 * 60 * 1000;

        const dDate = new Date(d);
        dateRangeMatch =
          new Date(porim.effectivefromdt) <= new Date(dDate) &&
          new Date(porim.effectivetodt) >= new Date(timesheet.weekEndDate);
      } else {
        dateRangeMatch =
          new Date(porim.effectivefromdt) <=
            new Date(
              timesheet.startDate
                ? timesheet.startDate
                : timesheet.workStartDate,
            ) &&
          new Date(porim.effectivetodt) >=
            new Date(
              timesheet.endDate ? timesheet.endDate : timesheet.workEndDate,
            );
      }

      const statusMatch =
        porim.statuscode === null || porim.statuscode !== 'INACTIVE';

      const latestMatch = porim.latest === true;

      return laborMatch && dateRangeMatch && statusMatch && latestMatch;
    });
    timesheetLaborData[i].polaborrateid = resData?.polaborrateid;
  }
  const labourHoursColumns = {
    dailyHours: { poLab: 'dailywage' },
    dtLaborHours: {
      poLab: 'dtlaborrate',
      shifts: {
        1: 'dtloadedrate',
        2: 'scndshftdtloadedrate',
        3: 'thrdshftdtloadedrate',
      },
    },
    dtxHours: { poLab: 'dtxlaborrate' },
    emerHours: { poLab: 'emergencycallout' },
    holidayPayHours: { poLab: 'holidaypay' },
    monthlyHours: { poLab: 'monthlywage' },
    otLaborHours: {
      poLab: 'otlaborrate',
      shifts: {
        1: 'thloadedrate',
        2: 'scndshftthloadedrate',
        3: 'thrdshftthloadedrate',
      },
    },
    peakSeasonHours: { poLab: 'peakseason' },
    regLaborHours: {
      poLab: 'stlaborrate',
      shifts: {
        1: 'stloadedrate',
        2: 'scndshftstloadedrate',
        3: 'thrdshftstloadedrate',
      },
    },
    rhxHours: { poLab: 'rhxlaborrate' },
    standbyHours: { poLab: 'standby' },
    travelHours: { poLab: 'travelrate' },
    weeklyHours: { poLab: 'weeklywage' },
  };
  const unitHoursColumns = {
    demobUnits: { poLab: 'demobilization' },
    perDiemUnits: { poLab: 'perdiemrate' },
    mobUnits: { poLab: 'mobilization' },
  };

  return calculateLine(
    timesheetLaborData,
    polaborratesData,
    labourHoursColumns,
    unitHoursColumns,
    'labor',
    'laborCode',
    'polaborrateid',
    po,
  );
};

export const calculateReiumbursable = (po, timesheet) => {
  const poexprateData = po?.originalData?.poexprates;
  const timesheetReimbursableData = timesheet?.timesheetReimbursables;

  for (let i = 0; i < timesheetReimbursableData.length; i++) {
    const resData = poexprateData.find(porim => {
      const expcodeMatch =
        porim.expcode === timesheetReimbursableData[i].expcode;
      let dateRangeMatch = '';
      if (['DISTRIBUTION', 'FORESTRY'].includes(po?.buPath)) {
        const d =
          new Date(timesheet.weekEndDate).getTime() - 6 * 24 * 60 * 60 * 1000;

        const dDate = new Date(d);
        dateRangeMatch =
          new Date(porim.effectivefromdt) <= new Date(dDate) &&
          new Date(porim.effectivetodt) >= new Date(timesheet.weekEndDate);
      } else {
        dateRangeMatch =
          new Date(porim.effectivefromdt) <=
            new Date(
              timesheet.startDate
                ? timesheet.startDate
                : timesheet.workStartDate,
            ) &&
          new Date(porim.effectivetodt) >=
            new Date(
              timesheet.endDate ? timesheet.endDate : timesheet.workEndDate,
            );
      }

      const statusMatch =
        porim.statuscode === null || porim.statuscode !== 'INACTIVE';

      const latestMatch = porim.latest === true;

      return expcodeMatch && dateRangeMatch && statusMatch && latestMatch;
    });
    timesheetReimbursableData[i].poexprateid = resData?.poexprateid;
  }
  const labourHoursColumns = {
    // reimbPrice: { poLab: 'price' },
  };
  const unitHoursColumns = {
    reimbUnitmeasure: { poLab: 'unitmeasure' },
  };

  return calculateLine(
    timesheetReimbursableData,
    poexprateData,
    labourHoursColumns,
    unitHoursColumns,
    'reimb',
    'reimbCode',
    'poexprateid',
    po,
  );
};

export const calculateUptasks = (po, timesheet) => {
  const poUpRate = po?.originalData?.pouprates;
  const timesheetUptaskData = timesheet?.timesheetUptasks;
  for (let i = 0; i < timesheetUptaskData.length; i++) {
    const resData = poUpRate.find(porim => {
      const expcodeMatch = porim.taskcode === timesheetUptaskData[i].code;

      let dateRangeMatch = '';
      if (['DISTRIBUTION', 'FORESTRY'].includes(po?.buPath)) {
        const d =
          new Date(timesheet.weekEndDate).getTime() - 6 * 24 * 60 * 60 * 1000;

        const dDate = new Date(d);
        dateRangeMatch =
          new Date(porim.effectivefromdt) <= new Date(dDate) &&
          new Date(porim.effectivetodt) >= new Date(timesheet.weekEndDate);
      } else {
        dateRangeMatch =
          new Date(porim.effectivefromdt) <=
            new Date(
              timesheet.startDate
                ? timesheet.startDate
                : timesheet.workStartDate,
            ) &&
          new Date(porim.effectivetodt) >=
            new Date(
              timesheet.endDate ? timesheet.endDate : timesheet.workEndDate,
            );
      }

      const statusMatch =
        porim.statuscode === null || porim.statuscode !== 'INACTIVE';

      const latestMatch = porim.latest === true;

      return expcodeMatch && dateRangeMatch && statusMatch && latestMatch;
    });
    timesheetUptaskData[i].pouprateid = resData?.pouprateid;
  }

  const labourHoursColumns = {
    // hours: { poLab: 'hours' },
  };
  const unitHoursColumns = {
    totalPrice: { poLab: 'totalunitprice' },
  };
  return calculateLine(
    timesheetUptaskData,
    poUpRate,
    labourHoursColumns,
    unitHoursColumns,
    'uptask',
    'code',
    'pouprateid',
    po,
  );
};

export const calculateEqpRates = (po, timesheet, fuelResponse) => {
  const poeqptratesData = po?.originalData?.poeqptrates;
  const timesheetEqpData = _.cloneDeep(timesheet?.timesheetEquipments);
  for (let i = 0; i < timesheetEqpData.length; i++) {
    const resData = poeqptratesData.find(porim => {
      const expcodeMatch = porim.rentalitemno === timesheetEqpData[i].equipCode;

      let dateRangeMatch = '';
      if (['DISTRIBUTION', 'FORESTRY'].includes(po?.buPath)) {
        const d =
          new Date(timesheet.weekEndDate).getTime() - 6 * 24 * 60 * 60 * 1000;

        const dDate = new Date(d);
        dateRangeMatch =
          new Date(porim.effectivefromdt) <= new Date(dDate) &&
          new Date(porim.effectivetodt) >= new Date(timesheet.weekEndDate);
      } else {
        dateRangeMatch =
          new Date(porim.effectivefromdt) <=
            new Date(
              timesheet.startDate
                ? timesheet.startDate
                : timesheet.workStartDate,
            ) &&
          new Date(porim.effectivetodt) >=
            new Date(
              timesheet.endDate ? timesheet.endDate : timesheet.workEndDate,
            );
      }

      const statusMatch =
        porim.statuscode === null || porim.statuscode !== 'INACTIVE';

      const latestMatch = porim.latest === true;

      return expcodeMatch && dateRangeMatch && statusMatch && latestMatch;
    });
    timesheetEqpData[i].poeqptrateid = resData?.poeqptrateid;

    timesheetEqpData[i].fuelRate = fuelResponse?.fuel_rate;
  }

  const eqpHoursColumns = {
    opHours: { poLab: 'operatingrate' },
    otHours: { poLab: 'otrate' },
    stHours: { poLab: 'standbyrate' },
    equipmentRentalUnits: { poLab: 'eqptrntlrate' },
  };
  const unitHoursColumns = {
    demobUnits: { poLab: 'demobilization' },
    mobUnits: { poLab: 'mobilization' },
    miles: { poLab: 'costpermile' },
  };
  const calculatedLineData = calculateLine(
    timesheetEqpData,
    poeqptratesData,
    eqpHoursColumns,
    unitHoursColumns,
    'equip',
    'equipCode',
    'poeqptrateid',
    po,
  );

  // ECA-13252 ----------------------
  let { lineData, total, fuelAdjCost } = calculatedLineData;
  // debugger;
  // total = 0;
  // for (const key in lineData) {
  //   // Adding usagediscount, usagediscrate, isDiscounted fields
  //   lineData[key].usagediscrate = null;
  //   lineData[key].usagediscount = null;
  //   lineData[key].isDiscounted = false;
  //   const selectedTimesheetEq = timesheetEqpData.filter(
  //     tse =>
  //       tse.timeEquipmentNmbr == lineData[key].timeEquipmentNmbr &&
  //       tse.isDiscounted == true,
  //   );
  //   if (selectedTimesheetEq.length > 0) {
  //     const selectedPoeqData = poeqptratesData.filter(
  //       peq => peq.poeqptrateid == selectedTimesheetEq[0].poeqptrateid,
  //     )[0];
  //     // Applying usagedisrate if any else usagediscount
  //     if (selectedPoeqData.usagediscrate != null) {
  //       lineData[key].lineTotal =
  //         Math.round(
  //           lineData[key].equipHours * selectedPoeqData.usagediscrate * 100,
  //         ) / 100;
  //       lineData[key].usagediscrate = selectedPoeqData.usagediscrate;
  //       lineData[key].isDiscounted = true;
  //     } else if (selectedPoeqData.usagediscount) {
  //       lineData[key].lineTotal =
  //         Math.round(
  //           lineData[key].equipHours * selectedPoeqData.usagediscount * 100,
  //         ) / 100;
  //       lineData[key].usagediscount = selectedPoeqData.usagediscount;
  //       lineData[key].isDiscounted = true;
  //     }
  //   }
  //   total += Math.round(lineData[key].lineTotal * 100) / 100;
  // }
  return { lineData, total, fuelAdjCost };
};

/***
 * Calcluate the line totals
 */
export const calculateLine = (
  timesheetData,
  poRate,
  hoursColumns,
  unitColumns,
  type,
  code,
  compareField,
  po,
) => {
  const lineData = [];
  let total = 0;
  let fuelAdjCost = 0;
  for (const laborHrtype in hoursColumns) {
    for (const timeSheetLd of timesheetData) {
      if (timeSheetLd[laborHrtype] === undefined) {
        continue;
      }
      let hours = null;
      let lineType = null;
      let poField = null;
      let units = null;
      let rate = null;
      let discountRate = null;
      let discountedHours = null;
      let quanity = null;
      let lineTotal = 0;
      let unitmeasure =
        timeSheetLd.equipUnitmeasure ||
        timeSheetLd.reimbUnitmeasure ||
        timeSheetLd.unitmeasure;
      let findPoRate;
      let fuelAdj = 0;
      let fuelRate;

      if (type === 'equip' && po?.buPath === 'DISTRIBUTION') {
        fuelRate = timeSheetLd?.fuelRate;
      }
      // Check which value is set
      if (type === 'labor' || type === 'equip') {
        if (
          !isNaN(timeSheetLd[laborHrtype]) &&
          Number(timeSheetLd[laborHrtype]) !== 0
        ) {
          lineType = laborHrtype;
          hours = Number(timeSheetLd[laborHrtype]);

          if (timeSheetLd.shift && hoursColumns[laborHrtype].shifts) {
            poField =
              hoursColumns[laborHrtype].shifts[timeSheetLd.shift] ||
              hoursColumns[laborHrtype].poLab;
          } else {
            poField = hoursColumns[laborHrtype].poLab;
          }
        } else {
          continue;
        }

        for (const poData of poRate) {
          if (poData[compareField] === timeSheetLd[compareField]) {
            if (poData[poField] !== undefined && poData[poField] !== null) {
              rate = poData[poField];
              findPoRate = poData;
              break;
            }
          }
        }
        if (findPoRate) {
          const { basefuelrate, galperhr, fueltolerance } = findPoRate;
          const fuelAdj =
            (fuelRate - Number(basefuelrate || 0)) *
            Number(galperhr || 0) *
            hours;
          fuelAdjCost += fuelAdj;
        }
        //
        if (rate && !isNaN(rate)) {
          rate = Number(rate);
        } else {
          rate = 0;
        }

        if (hours && !isNaN(hours)) {
          hours = Number(hours);
          lineTotal = hours * rate;
        }

        if (units && !isNaN(units)) {
          units = Number(units);
          lineTotal = units * rate;
        }
      } else {
        for (const poData of poRate) {
          if (poData[compareField] === timeSheetLd[compareField]) {
            if (poData.price || poData.totalunitprice) {
              rate = Number(poData.price || poData.totalunitprice);
              findPoRate = poData;
              break;
            }
          }
        }

        if (type === 'reimb') {
          units = timeSheetLd.reimbQuantity;
          // rate = timeSheetLd.reimbPrice;
        }
        if (type === 'uptask') {
          units = timeSheetLd.quantity;
          if (!rate && timeSheetLd.totalPrice) {
            rate = timeSheetLd.totalPrice;
          }
        }

        lineTotal = units * rate;
      }

      const poData = po.ponum;

      const costActivityData = po?.pocostactivities;
      const polinenum = costActivityData ? costActivityData.polinenum : null;
      const ponum = poData.ponum;
      let exceedsPolineThreshold = false;
      const lineItem = {
        [`${type}Code`]: timeSheetLd[code], //"from timesheet_labor.code",
        [`${type}Description`]: timeSheetLd.description, //"from timesheet_labor.description",
        [`${type}Rate`]: rate, //"(associated rate from polaborrate table)",
        [`${type}Units`]: units, //"(from timesheet_labor field entered, if the field is entered for hours then null)",
        [`${type}Hours`]: hours, //"(from timesheet_labor field entered, if the field is entered in units then null)",
        [`${type}Type`]: lineType, //"the field name read from the timesheet record i.e reg_hours",
        activitynum: timeSheetLd.activitynum, //"from timesheet_labor.activitynum",
        activityDescription: timeSheetLd.activityDescription, //"from timesheet_labor.activity_description",
        rateschDescription: timeSheetLd.rateschDescription, //"from timesheet_labor.activity_description",
        rateschRevNo: findPoRate?.rateschrevno, //"from poRate.rateschrevno",
        lineTotal, //"(either rate x units  or rate x hours )",
        [`${type}Unitmeasure`]: unitmeasure,
        polinenum: polinenum ? polinenum.toString() : '',
        exceedsPolineThreshold,
        timesheetId: timeSheetLd.recordNmbr,
      };
      if (type === 'equip') {
        lineItem['fuelAdj'] = fuelAdj;
        lineItem['timeEquipmentNmbr'] = timeSheetLd.timeEquipmentNmbr;
      }
      if (type === 'labor') {
        lineItem['employeeId'] = timeSheetLd.employeeId;
        lineItem['employeeName'] = timeSheetLd.employeeName;
        lineItem['shift'] = timeSheetLd.shift;
        lineItem['timeLaborNmbr'] = timeSheetLd.timeLaborNmbr;
      }
      if (type === 'reimb') {
        lineItem['basepricemarkup'] = findPoRate
          ? Number(findPoRate.basepricemarkup || 0)
          : 0;
        lineItem['miscellaneousmarkup'] = findPoRate
          ? Number(findPoRate.miscellaneousmarkup || 0)
          : 0;
        lineItem['deliverymarkup'] = findPoRate
          ? Number(findPoRate.deliverymarkup || 0)
          : 0;
        const baseTotal = units * rate;
        const totalMarkup =
          (lineItem.miscellaneousmarkup / 100 +
            lineItem.basepricemarkup / 100 +
            lineItem.deliverymarkup / 100) *
          baseTotal;
        lineItem['totalmarkup'] = Math.round(totalMarkup * 100) / 100;
        lineItem['baseTotal'] = Math.round(baseTotal * 100) / 100;
        lineItem['lineTotal'] =
          Math.round((baseTotal + totalMarkup) * 100) / 100;
        lineItem['rateschRevNo'] = findPoRate?.rateschrevno;
        lineItem['timeExpenseNmbr'] = timeSheetLd.timeExpenseNmbr;
      }
      lineData.push(lineItem);

      if (discountRate && discountedHours) {
        let copyLine = { ...lineItem };
        lineItem[`${type}Rate`] = discountRate;
        lineItem[`${type}Hours`] = discountedHours;
        lineItem['lineTotal'] = discountRate * discountedHours;
        lineData.push(copyLine);
      }
      // total = +lineTotal;
    }
  }

  for (const laborHrtype in unitColumns) {
    for (const timeSheetLd of timesheetData) {
      if (timeSheetLd[laborHrtype] === undefined) {
        continue;
      }
      // if (type === 'uptask')
      let hours = null;
      let lineType = null;
      let poField = null;
      let units = null;
      let rate = null;
      let quanity = null;
      let lineTotal = 0;
      let unitmeasure =
        timeSheetLd.equipUnitmeasure ||
        timeSheetLd.reimbUnitmeasure ||
        timeSheetLd.unitmeasure;
      let findPoRate;

      // Check which value is set
      if (type === 'labor' || type === 'equip') {
        if (
          !isNaN(timeSheetLd[laborHrtype]) &&
          Number(timeSheetLd[laborHrtype]) !== 0
        ) {
          lineType = laborHrtype;
          units = Number(timeSheetLd[laborHrtype]);
          poField = unitColumns[laborHrtype].poLab;
        } else {
          continue;
        }

        // Mapping the rate
        for (const poData of poRate) {
          console.log(poData[compareField], '==', timeSheetLd[compareField]);
          if (poData[compareField] === timeSheetLd[compareField]) {
            if (poData[poField] !== undefined && poData[poField] !== null) {
              rate = poData[poField];
              findPoRate = poData;
              break;
            }
          }
        }
        //
        if (rate && !isNaN(rate)) {
          rate = Number(rate);
        } else {
          rate = 0;
        }

        // if (type === 'equip' && lineType === 'opHours' && findPoRate) {
        //   const usagemodifier = Number(findPoRate.usagemodifier);
        //   if (usagemodifier && usagemodifier > 0) {
        //     const hours = await getEqpHours(poid, {
        //       equipId: findPoRate.equipId,
        //       equipCode: findPoRate.equipCode,
        //     });
        //     let equipHistHours = 0;
        //     for (const hour of hours) {
        //       equipHistHours += Number(hour.equipHours || 0);
        //     }
        //     const opHours = Number(timeSheetLd.opHours || 0);
        //     if (opHours + equipHistHours > usagemodifier) {
        //       rate = Number(findPoRate.usagediscrate)
        //         ? Number(findPoRate.usagediscrate)
        //         : Number(findPoRate.usagediscount)
        //         ? rate - rate * (usagediscount / 100)
        //         : rate;
        //     }
        //   }
        // }

        if (hours && !isNaN(hours)) {
          hours = Number(hours);
          lineTotal = Math.round(hours * rate * 100) / 100;
        }
        if (units && !isNaN(units)) {
          units = Number(units);
          lineTotal = Math.round(units * rate * 100) / 100;
        }
      } else {
        for (const poData of poRate) {
          if (poData[compareField] === timeSheetLd[compareField]) {
            if (poData.price || poData.totalunitprice) {
              rate = Number(poData.price || poData.totalunitprice);
              findPoRate = poData;
              break;
            }
          }
        }
        if (type === 'reimb') {
          units = timeSheetLd.reimbQuantity;
        }
        if (type === 'uptask') {
          units = timeSheetLd.quantity;
          if (!rate && timeSheetLd.totalPrice) {
            rate = timeSheetLd.totalPrice;
          }
        }
        lineTotal = units * rate;
      }

      let exceedsPolineThreshold = false;

      const lineItem = {
        [`${type}Code`]: timeSheetLd[code], //"from timesheet_labor.code",
        [`${type}Description`]: timeSheetLd.description, //"from timesheet_labor.description",
        [`${type}Rate`]: rate, //"(associated rate from polaborrate table)",
        [`${type}Units`]: units, //"(from timesheet_labor field entered, if the field is entered for hours then null)",
        [`${type}Hours`]: hours, //"(from timesheet_labor field entered, if the field is entered in units then null)",
        [`${type}Type`]: lineType, //"the field name read from the timesheet record i.e reg_hours",
        activitynum: timeSheetLd.activitynum, //"from timesheet_labor.activitynum",
        activityDescription: timeSheetLd.activityDescription, //"from timesheet_labor.activity_description",
        rateschDescription: timeSheetLd.rateschDescription, //"from timesheet_labor.ratesch_description",
        rateschRevNo: poRate?.rateschrevno, //"from poRate.rateschrevno",
        lineTotal, //"(either rate x units  or rate x hours )",
        [`${type}Unitmeasure`]: unitmeasure,
        exceedsPolineThreshold,
        timesheetId: timeSheetLd.recordNmbr,
      };
      if (type === 'labor') {
        lineItem['employeeId'] = timeSheetLd.employeeId;
        lineItem['employeeName'] = timeSheetLd.employeeName;
      }
      if (type === 'reimb') {
        lineItem['rateschRevNo'] = findPoRate?.rateschrevno;
        lineItem['basepricemarkup'] = findPoRate
          ? Number(findPoRate.basepricemarkup || 0)
          : 0;
        lineItem['miscellaneousmarkup'] = findPoRate
          ? Number(findPoRate.miscellaneousmarkup || 0)
          : 0;
        lineItem['deliverymarkup'] = findPoRate
          ? Number(findPoRate.deliverymarkup || 0)
          : 0;
        const baseTotal = units * rate;
        const totalMarkup =
          (lineItem.miscellaneousmarkup / 100 +
            lineItem.basepricemarkup / 100 +
            lineItem.deliverymarkup / 100) *
          baseTotal;
        lineItem['totalmarkup'] = Math.round(totalMarkup * 100) / 100;
        lineItem['baseTotal'] = Math.round(baseTotal * 100) / 100;
        lineItem['lineTotal'] =
          Math.round((baseTotal + totalMarkup) * 100) / 100;
        lineItem['timeExpenseNmbr'] = timeSheetLd.timeExpenseNmbr;
      }
      if (type === 'uptask') {
        lineItem['rateschRevNo'] = findPoRate?.rateschrevno;
        lineItem['uptaskHours'] = timeSheetLd.hours;
      }
      lineData.push(lineItem);
    }
  }

  lineData.forEach(itm => {
    itm.lineTotal = Math.round(itm.lineTotal * 100) / 100;
    total += itm.lineTotal;
    total = Math.round(total * 100) / 100;
  });

  total = Math.round(total * 100) / 100;
  return { lineData, total, fuelAdjCost };
};
